import React from "react";
import { AlertTriangle, X } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

/** Q5: "File too big — please split it and upload" cards (WhatsApp / email / Drive drop / upload). Clears on dismiss or replacement upload. */
export const ActionNeeded = ({ items, onChanged, showCase }) => {
  if (!items || items.length === 0) return null;
  const dismiss = async (a) => {
    try { await api.post(`/cases/${a.case_record_id}/action-needed/${a.action_id}/dismiss`); toast.success("Dismissed"); onChanged && onChanged(); }
    catch { toast.error("Failed"); }
  };
  return (
    <div className="space-y-1" data-testid="action-needed">
      {items.map((a) => (
        <div key={a.action_id} className="flex items-start gap-2 text-xs bg-[#CA1212]/5 border border-[#CA1212]/30 rounded-lg px-3 py-1.5" data-testid={`action-needed-${a.action_id}`}>
          <AlertTriangle className="w-3.5 h-3.5 text-[#CA1212] mt-0.5 shrink-0" />
          <div className="flex-1 min-w-0">
            {showCase && a.case_id && <span className="font-mono text-[#E2521B] mr-1">{a.case_id}</span>}
            <b className="text-[#333333]">{a.message}</b> · <span className="truncate">{a.name}</span> · via {a.source_label}{a.sender ? ` (${a.sender})` : ""}
            {a.link && <> · <a href={a.link} target="_blank" rel="noreferrer" className="underline" data-testid={`action-needed-link-${a.action_id}`}>open original</a></>}
          </div>
          <button onClick={() => dismiss(a)} className="text-[#6B7280] hover:text-[#333333]" data-testid={`action-needed-dismiss-${a.action_id}`} title="Dismiss"><X className="w-3.5 h-3.5" /></button>
        </div>
      ))}
    </div>
  );
};
